import { UserData, userDataDefault } from "modules/authentication/types/user-data";

export const LOCATION_UPDATED_EVENT = "carriapp-location-updated";

/**
 * Domain error raised when a guest tries to add to cart without selecting a location.
 */
export class LocationRequiredError extends Error {
    constructor(message = "Location selection is required") {
        super(message);
        this.name = "LocationRequiredError";
    }
}

/**
 * Reads and normalizes user data from localStorage.
 */
export const readUserDataFromLocalStorage = (): UserData => {
    try {
        const rawData = localStorage.getItem("userData");
        if (!rawData) {
            return userDataDefault;
        }

        const parsed = JSON.parse(rawData) as Partial<UserData>;
        return {
            ...userDataDefault,
            ...parsed,
        };
    } catch (_error) {
        return userDataDefault;
    }
};

/**
 * Returns true when the user profile represents a non-authenticated session.
 */
export const isGuestUser = (userData: UserData): boolean => {
    return !userData.id;
};

/**
 * Returns true when the user has selected a location other than the default placeholder.
 */
export const hasSelectedLocation = (userData: UserData): boolean => {
    return Boolean(userData.location_id) && userData.location_id !== 1;
};

/**
 * Returns the label shown by the location selector trigger.
 */
export const getLocationSelectorLabel = (userData: UserData): string => {
    if (!hasSelectedLocation(userData)) {
        return "Selecciona tu ubicación";
    }

    return userData.location_name || "Selecciona tu ubicación";
};
